import React, { useState, useEffect , useRef} from 'react';
import { Form } from 'react-bootstrap';
import PersistStorage from '../../utils/helpers/PersistStorage';
import DateTimeUtils from '../../utils/DateTimeUtility';

const DateTimePicker = (props = {}) => {
    let startDate = new Date();
    let state = {
        placeholder:"",
        disable:false,
        id:"",
        className:props.options.className,
        hidePlaceholder:false,
        styles:{width:"160px",marginLeft:"10px", height: "38px", fontSize: "inherit" },
        initialDate:"now"

    };
    const [selectedDate, setSelectedDate] = useState((startDate.getFullYear() + (startDate.getMonth()< 9 ? "-0" : "-") + 
        (startDate.getMonth() + 1) + "-" + (parseInt(startDate.getDate()) < 10?"0"+startDate.getDate():startDate.getDate()))
    );
    const TimerIntervalRef = useRef(null); //Timer for user entry on Date
    state = {...state, ...props.options};
    if(state.initialDate !== "now"){
        startDate = state.initialDate;
    }
    
    const handleDateTimePickerChange = (e) => {
        try{
            const timeout = 1500;
            let inputDate = e.target.value;
            PersistStorage.save("selectedDate", inputDate, 999, true);
            
            setSelectedDate(inputDate);

            if(TimerIntervalRef.current){clearTimeout(TimerIntervalRef.current);}
            
            TimerIntervalRef.current = setTimeout(function(){
                try{
                    if(typeof props.SelectionChangeCallback === "function"){
                        inputDate = DateTimeUtils.sanitizeDateInput(inputDate);
                        props.SelectionChangeCallback(inputDate);
                        setSelectedDate(inputDate);
                        PersistStorage.save("selectedDate", inputDate, 999, true);
                    }
                    
                }
                catch(err){console.log(err);}
            }, timeout);
            
        }
        catch(err){console.log(err);}
    };

    useEffect(() => {
        if (props.SelectedDate) {
            setSelectedDate(props.SelectedDate);
        }
    }, [props.SelectedDate]);
    
    return(
        <Form.Group className={state.className}>
            <Form.Control type="date" max={(props.options.maxLimit ? props.options.maxLimit : undefined)} min={"1900-01-01"} placeholder="" style={state.styles} 
                onChange={handleDateTimePickerChange} value={selectedDate} disabled={state.disable} 
            /> 
        </Form.Group>
    )
}
 
export default DateTimePicker;